module.exports = __webpack_public_path__ + "static/media/icon4.f667cacc.svg";